import React from "react";
import styles from "../styles/Header.module.css";

const WritingPage = () => (
  <div className={styles.page}>
    <section className={styles.writing}>
      <div className={styles.sectionWrap}>
        <h2 className={styles.sectionHeading}>Writing</h2>
        <p className={styles.writingBio}>
          I write about frontend engineering, sustainable software, and travel
          tech on Hashnode.
        </p>
        <a
          href="https://hashnode.com/@mercyio"
          target="_blank"
          rel="noreferrer"
          className={styles.hashnodeLink}
        >
          Read on Hashnode ↗
        </a>
      </div>
    </section>
  </div>
);

export default WritingPage;
